import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.add-account', {
        url: '/add-account',
        component: 'companyUserDirectoriesManageUserAddAccount',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/add-account/add-account.state.js